import { types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
import { AxiosResponse } from "axios";

const prefixUrl = "/activity";

export default {
    async list(param: types.activity.ReqActivityList): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/list", param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async detail(idx: number): Promise<types.activity.ResActivity> {
        const res = {} as types.activity.ResActivity;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/detail/" + idx, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async add(param: types.activity.ReqActivity): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            const formData: FormData = new FormData();
            Object.entries(param).forEach(([key, value]) => {
                if (value instanceof File || value instanceof Blob) {
                    formData.append(key, value);
                } else if (value instanceof Array) {
                    value.forEach((item) => {
                        formData.append(key, item);
                    });
                } else if (value !== undefined && value !== null) {
                    formData.append(key, String(value));
                }
            });
            header.headers["Content-Type"] = "multipart/form-data";
            const response = await apiService().post(prefixUrl + "/add", formData, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async modify(param: types.activity.ReqActivityForModify): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            const formData: FormData = new FormData();
            Object.entries(param).forEach(([key, value]) => {
                if (value instanceof File || value instanceof Blob) {
                    formData.append(key, value);
                } else if (value instanceof Array) {
                    value.forEach((item) => {
                        formData.append(key, item);
                    });
                } else if (value !== undefined && value !== null) {
                    formData.append(key, String(value));
                }
            });
            header.headers["Content-Type"] = "multipart/form-data";
            const response = await apiService().post(prefixUrl + "/modify", formData, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async remove(idx: number): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/remove/" + idx, null, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async removeForFile(idx: number, idxFile: number): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/remove/" + idx + "/" + idxFile, null, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async exportExcel(param: types.activity.ReqActivityList): Promise<any> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response: AxiosResponse<Blob> = await apiService().post(prefixUrl + "/excel/download", param, {
                withCredentials: false,
                responseType: "blob",
            });

            return response;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },
};
